// ChecklistTemplate — an org-owned bloque catalog for facility_management's
// acta_visita (ADR-0068), scoped either brand-wide or to specific stores
// (ADR-0079). Exists so the four write endpoints in
// apps/core-api/src/routes/checklist-templates.ts derive their bodies
// instead of hand-rolling a parallel field list — see ADR-0079 Decision 5.
//
// `brandId` has no branded id type of its own (no `brands` entity exists
// in this package yet; the wire layer has never surfaced it either — see
// packages/api-types/src/checklist-templates.ts), so it's a plain
// nullable uuid string here rather than a `brandIdSchema`.
import { isoDateTimeSchema, uuidSchema } from "@bitacorapro/shared";
import { z } from "zod";
import { checklistTemplateIdSchema, organizationIdSchema } from "../ids.js";
// Never derived from checklist_template_assets row count — see the
// comment on checklist_templates.scope in apps/core-api/src/db/schema.ts
// for why an explicit column beats an inferred one.
export const checklistTemplateScopeSchema = z.enum(["brand", "assets"]);
export const checklistTemplateSchema = z.object({
    id: checklistTemplateIdSchema,
    organizationId: organizationIdSchema,
    brandId: uuidSchema.nullable(),
    label: z.string().trim().min(1).max(200),
    /** Raw day-count freshness input (ADR-0068). Null = no "al día" pill
     *  computed for this template — a deliberate per-template opt-out. */
    cadenceDays: z.number().int().positive().nullable(),
    displayOrder: z.number().int(),
    active: z.boolean(),
    scope: checklistTemplateScopeSchema,
    createdAt: isoDateTimeSchema,
    updatedAt: isoDateTimeSchema,
});
//# sourceMappingURL=checklist-template.js.map